import React from "react";
import {
    addProductButtonStyle,
    cnoFooterStyle,
    cnoHeaderStyle,
    cnoRowsStyle,
    cnoRowStyle,
    cnoSectionStyle,
    deleteLineButtonStyle,
    emptyStyle,
    inputStyle,
    labelStyle,
    lineIndexStyle,
    saveCnoButtonStyle,
} from "./cnoStyles";

function CnoLineRow({ line, index, onUpdate, onDelete }) {
    return (
        <div className="cno-row" style={cnoRowStyle}>
            <span style={lineIndexStyle}>{index + 1}</span>
            <label style={labelStyle}>
                Nom du produit
                <input
                    style={inputStyle}
                    value={line.produit}
                    onChange={event => onUpdate(line.clientId, { produit: event.target.value })}
                />
            </label>
            <label style={labelStyle}>
                Quantité
                <input
                    type="number"
                    min="0"
                    step="1"
                    style={inputStyle}
                    value={line.quantite}
                    onChange={event => onUpdate(line.clientId, { quantite: event.target.value })}
                />
            </label>
            <button
                type="button"
                className="cno-delete-button"
                onClick={() => onDelete(line)}
                aria-label={`Supprimer le produit ${line.produit || index + 1}`}
                style={deleteLineButtonStyle}
            >
                Supprimer
            </button>
        </div>
    );
}

// Lignes CNO de la fiche, avec enregistrement groupé et ajout d'un produit.
export default function CnoLinesSection({ lines, readyCount, onUpdate, onDelete, onSave, onAdd }) {
    const nothingToSave = readyCount === 0;
    return (
        <div style={cnoSectionStyle}>
            <div style={cnoHeaderStyle}>
                <h3 style={{ margin: 0, color: "#111827", fontSize: "16px" }}>CNO</h3>
                <span style={{ color: "#64748b", fontSize: "13px", fontWeight: 700 }}>
                    {lines.length} ligne(s)
                </span>
            </div>
            {lines.length === 0 ? (
                <p style={emptyStyle}>Aucune ligne CNO pour ce patient.</p>
            ) : (
                <div style={cnoRowsStyle}>
                    {lines.map((line, index) => (
                        <CnoLineRow key={line.clientId} line={line} index={index} onUpdate={onUpdate} onDelete={onDelete} />
                    ))}
                </div>
            )}
            <div style={cnoFooterStyle}>
                <button type="button" onClick={onSave} disabled={nothingToSave} style={saveCnoButtonStyle(nothingToSave)}>
                    Enregistrer
                </button>
                <button
                    type="button"
                    onClick={onAdd}
                    style={addProductButtonStyle}
                    onMouseEnter={event => { event.currentTarget.style.background = "#1e293b"; }}
                    onMouseLeave={event => { event.currentTarget.style.background = "#0f172a"; }}
                >
                    + Ajouter un produit
                </button>
            </div>
        </div>
    );
}
